<div class="response table-responsive m-b-2">
    <table class="est-table building-table" cellspacing="0">
        <thead>
            <tr>
                <th>Property Uid</th>
                <th>Unit Uid</th>
                <th>Floor Uid</th>
                <th>Unit Type</th>
                <th>Unit Sub Type</th>
                <th>Unit Area (sqm)</th>
                <th>Unit Number</th>
                <th>Category</th>
                <th>Shop Name</th>
                <th>Sub Category</th>
                <th>Cuisine</th>
                <th>No Of Full Bathroom</th>
                <th>No Of Half Bathroom</th>
                <th>No Of Master Bedroom</th>
                <th>Parent Unit Uid</th>
                <th>No Of Balcony</th>
                <th>No Of Bedroom</th>
                <th>No Of Kitchen</th>
                <th>No Of Living Room</th>
                <th>No Of Diwania</th>
                <th>No Of Driver Room</th>
                <th>No Of Maid Room</th>
                <th>Unit Name</th>
                <th>Main Category</th>
                <th>Department</th>
            </tr>
        </thead>
        <tbody>
            @for (item of tableData; track $index) {
                <tr>
                    <td>{{item.property_uid || '-'}}</td>
                    <td>{{item.unit_uid || '-'}}</td>
                    <td>{{item.floor_uid || '-'}}</td>
                    <td>{{item.unit_type || '-'}}</td>
                    <td>{{item.unit_sub_type || '-'}}</td>
                    <td>{{item.unit_area ? (item.unit_area| number : '1.0-1') : '-'}}</td>
                    <td>{{item.unit_number || '-'}}</td>
                    <td>{{item.category || '-'}}</td>
                    <td>{{item.shop_name || '-'}}</td>
                    <td>{{item.sub_category || '-'}}</td>
                    <td>{{item.cuisine || '-'}}</td>
                    <td>{{item.no_of_full_bathroom || '-'}}</td>
                    <td>{{item.no_of_half_bathroom || '-'}}</td>
                    <td>{{item.no_of_master_bedroom || '-'}}</td>
                    <td>{{item.parent_unit_uid || '-'}}</td>
                    <td>{{item.no_of_balcony || '-'}}</td>
                    <td>{{item.no_of_bedroom || '-'}}</td>
                    <td>{{item.no_of_kitchen || '-'}}</td>
                    <td>{{item.no_of_living_room || '-'}}</td>
                    <td>{{item.no_of_diwania || '-'}}</td>
                    <td>{{item.no_of_driver_room || '-'}}</td>
                    <td>{{item.no_of_maid_room || '-'}}</td>
                    <td>{{item.unit_name || '-'}}</td>
                    <td>{{item.main_category || '-'}}</td>
                    <td>{{item.department || '-'}}</td>
                </tr>
                }
        </tbody>
    </table>

</div>
<div>
    @if(response){
        <app-table-pagination [tableData]="response" [itemsPerPage]="10" (filterData)="updateRecord($event)"></app-table-pagination>
    }
</div>